import { Box, lighten, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import Theme from "../utils/theme";
import { useMemo } from "react";

interface IPageIndicator {
    steps: number[];
    step: number;
    setStep: React.Dispatch<React.SetStateAction<number>>;
}

const PageIndicator: React.FC<IPageIndicator> = ({ steps, step, setStep }) => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);

    return (
        <>
            <Box sx={{ mt: 2, display: "flex", width: "100%", justifyContent: "center", alignItems: "center", position: "relative" }}>
                <Box
                    sx={{
                        height: "8px",
                        position: "absolute",
                        zIndex: -1,
                        width: String(40 * (steps.length + 1)) + "px",
                        backgroundColor: theme.palette.primary.main,
                    }}
                />
                {steps.map((item) => (
                    <Box
                        key={steps[item]}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "40px",
                            height: "40px",
                            mx: "20px",
                            color: item === step ? "white" : theme.palette.primary.main,
                            backgroundColor: item === step ? lighten(theme.palette.primary.main, 0.1) : "white",
                            border: "4px solid " + theme.palette.primary.main,
                            borderRadius: "50%",
                            cursor: "pointer",
                        }}
                        onClick={() => setStep(item)}
                    >
                        <Typography sx={{ fontWeight: 600 }}>{item}</Typography>
                    </Box>
                ))}
            </Box>
            <Box sx={{ display: "flex", mt: 1, mb: 2, width: "100%", justifyContent: "center", alignItems: "center" }}>
                <Typography variant="subtitle2">
                    Step {step + 1} : {step === 0 ? "Image upload" : step === 1 ? "Recipe selection" : "Recipe generation"}
                </Typography>
            </Box>
        </>
    );
};

export default PageIndicator;
